import { Text } from '../../components/Text';
import { RadioButtonGroupProps } from '../../components/RadioButtonGroup';

export const options: RadioButtonGroupProps['options'] = [
    {
        value: 'sm',
        label: <Text text="Small text size " fontWeight="semibold" variant="heading" size="sm" />,
        helperText: (
            <Text text="This is a sample text size that includes the number 1234." size="sm" />
        ),
    },
    {
        value: 'md',
        label: <Text text="Medium text size " fontWeight="semibold" variant="heading" size="md" />,
        helperText: (
            <Text text="This is a sample text size that includes the number 1234." size="md" />
        ),
    },
    {
        value: 'lg',
        label: <Text text="Large text size " fontWeight="semibold" variant="heading" size="lg" />,
        helperText: (
            <Text text="This is a sample text size that includes the number 1234." size="lg" />
        ),
    },
];
